(function () {
    'use strict';

    angular
        .module('app.roles')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'roles',
                config: {
                    url: '/roles',
                    title: 'Roller',
                    abstract: true,
                    templateUrl: 'app/roles/roles.html'
                }
            },
            {
                state: 'roles.list',
                config: {
                    templateUrl: 'app/roles/roles.list.html',
                    controller: 'RolesListController',
                    controllerAs: 'vm',
                    url: '/list',
                    title: 'Rol Listesi',
                    settings: {
                        nav: 4,
                        name: 'roles.list',
                        topName: 'system',
                        content: 'Rol Listesi',
                        resource: 'menu.roles.list'
                    }
                }
            }
        ];
    }
})();